<lib-activation-details [activationId]="activationId" [audienceId]="amsAudienceId" [breadcrumbParams]="[{label: 'Deliveries', route: returnRoute, order: 0}]"></lib-activation-details>
